import vars from '../../vars';
import { isProdDeploymentEnv } from '../../utils/environment';

// https://docs.sentry.io/clients/javascript/config/
export const sentryConfig = {
  environment: vars.get('TI_ENV'),
  release: RELEASE_VERSION,
  sampleRate: isProdDeploymentEnv() ? 0.075 : 0.5, // sample 7.5% in prod and 50% in non-prod
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0025,
};

export const sentryServerDsn = vars.get('SENTRY_DSN_SERVER');
export const sentryClientDsn = vars.get('SENTRY_DSN_CLIENT');
